// extracted by mini-css-extract-plugin
export default {"fr-view":"Tooltip_fr-view__OeU+6","container":"Tooltip_container__apgBQ"};